import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { ChevronLeftIcon } from '@root/shared/ui-kit'

type Props = {
  onBack: () => void
  title: React.ReactNode
}

export const BoardTitle: React.FC<Props> = ({ onBack, title }) => {
  return (
    <Root>
      <Button
        size="xs"
        variant="ghost"
        iconLeft={<ChevronLeftIcon />}
        onClick={onBack}
      />
      <Title>{title}</Title>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 2px;
  align-items: center;
  grid-auto-flow: column;
`

const Title = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`
